import { axiosDefaultConfig } from './axiosConfig';
import * as config from './config.json';
import Notifications from '../models/Notifications';
import { store } from '../redux/store';
import { SET_NOTIFICATIONS_TOTAL_PAGES } from '../redux/actions/types';
import { getNotificationsFromApi, getNotificationsTotalCountFromApi } from '../redux/actions/notifications';

export const markReaded = (notificationId: number) => {
  return new Promise<any>(async (resolve, reject) => {
    const url = config.NOTIFICATIONS_MARK_READED_BY_ID.replace('{notificationsId}', notificationId.toString());
    try {
      const response = await axiosDefaultConfig.put(url);
      if (response.status === 200) {
        store.dispatch(getNotificationsFromApi() as any);
        store.dispatch(getNotificationsTotalCountFromApi() as any);
        resolve(response.data);
      }
    } catch (error) {
      reject(error);
    }
  });
};

export const getNotifications = (pageNumber: number) => {
  return new Promise<Notifications[]>(async (resolve, reject) => {
    const url = config.NOTIFICATIONS;
    try {
      const notificationParam = {
        pageNumber,
        itemsPerPage: 5,
      };
      const response = await axiosDefaultConfig.post(url, notificationParam);
      store.dispatch({
        type: SET_NOTIFICATIONS_TOTAL_PAGES,
        payload: {
          ...store.getState().notificationsPages,
          totalPages: response.data.pageCount,
        },
      });

      resolve(response.data.collection);
    } catch (error) {
      reject(error);
    }
  });
};

export const getNotificationsTotalCount = () => {
  return new Promise<number>(async (resolve, reject) => {
    const url = config.NOTIFICATIONS_TOTAL_COUNT;
    try {
      const response = await axiosDefaultConfig.get(url);
      resolve(response.data);
    } catch (error) {
      reject(error);
    }
  });
};
